/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Preset_Name_PlaceholderInputs */

const en_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name for this preset`)
};

const fr_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un nom pour ce préréglage`)
};

const de_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Namen für diese Voreinstellung ein.`)
};

const it_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per questo preset`)
};

const ru_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите название для этого пресета.`)
};

const es_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca un nombre para este ajuste preestablecido`)
};

const zh_cn2_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请为此预设输入名称`)
};

const ja_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このプリセットの名前を入力してください`)
};

const hi_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस प्रीसेट के लिए एक नाम दर्ज करें`)
};

const pt_pt2_subtitle_export_preset_name_placeholder = /** @type {(inputs: Subtitle_Export_Preset_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira um nome para esta predefinição.`)
};

/**
* | output |
* | --- |
* | "Enter a name for this preset" |
*
* @param {Subtitle_Export_Preset_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_preset_name_placeholder = /** @type {((inputs?: Subtitle_Export_Preset_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Preset_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "de") return de_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "it") return it_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "ru") return ru_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "es") return es_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "ja") return ja_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "hi") return hi_subtitle_export_preset_name_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_preset_name_placeholder(inputs)
	return en_subtitle_export_preset_name_placeholder(inputs)
});